import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { CODIGO_ERRORES_HTTP } from '@core/constants/codigo-errores-http';
import { TipoError } from '@core/constants/tipo-error';
import { TelemetriaService } from '@core/services/telemetria.service';
import { esErrorInteraccionMsal, recuperarSesionMsal } from '@core/auth/recuperacion-sesion';
import { environment } from '@env/environment';

interface RespuestaError {
  fecha: string;
  ubicacion: string;
  mensaje: string;
}

@Injectable()
export class ManejadorErroresService implements ErrorHandler {
  private readonly telemetria = inject(TelemetriaService);
  private readonly injector = inject(Injector);

  public handleError(error: string | Error): void {
    if (esErrorInteraccionMsal(error)) {
      this.recuperarSesion();
      return;
    }

    if (error instanceof HttpErrorResponse) {
      this.telemetria.trackError(error);
      this.manejarErrorHttp(error);
      return;
    }

    if (error instanceof Error) {
      this.telemetria.trackError(error);
    }

    this.registrarError(error, TipoError.errorAplicacion);
  }

  private recuperarSesion(): void {
    const msalService = this.injector.get(MsalService);
    recuperarSesionMsal(() => {
      void msalService.instance.loginRedirect();
    });
  }

  private manejarErrorHttp(error: HttpErrorResponse): void {
    const mensaje = navigator.onLine
      ? `${CODIGO_ERRORES_HTTP[error.status] ?? CODIGO_ERRORES_HTTP.desconocido} (${error.url})`
      : CODIGO_ERRORES_HTTP.desconectado;

    this.registrarError(mensaje, TipoError.errorHttp);
  }

  private registrarError(error: string | Error, tipoError: string): void {
    const respuesta: RespuestaError = {
      fecha: new Date().toLocaleString(),
      ubicacion: globalThis.location.href,
      mensaje: typeof error === 'string' ? error : error.message,
    };

    if (!environment.production) {
      console.error(tipoError, respuesta);
    }
  }
}
